import { motion } from 'framer-motion';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';
import { popup } from '@telegram-apps/sdk-react';

import loadingAnimationData from '@/components/common/svg/assets/loader_v2.json';
import LottieAnimation from '@/animations/LottieAnimation.tsx';
import { useDialogsStore } from '@/store/useDialogsStore.ts';
import { giftActionButtonStyle } from '@/components/Messanger/Chat/ClaimGiftPopup/components/styles.ts';
import { routes } from '@/navigation/routes.tsx';

interface RejectGiftProps {
  contactId: string;
  contactName?: string;
}

const RejectGift: FC<RejectGiftProps> = ({ contactId, contactName }) => {
  const [isDeclining, setIsDeclining] = useState(false);
  const { declineGift } = useDialogsStore();

  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleRejectGift = () => {
    void popup
      .open({
        title: t('reject_gift_popup_title', { name: contactName ?? '-' }),
        message: t('reject_gift_popup_subtitle'),
        buttons: [
          {
            id: 'reject',
            type: 'destructive',
            text: t('reject_gift_confirm')
          },
          {
            id: 'cancel',
            type: 'default',
            text: t('reject_gift_cancel')
          }
        ]
      })
      .then(async (res) => {
        if (res === 'reject') {
          setIsDeclining(true);
          await declineGift(contactId);
          setIsDeclining(false);
          navigate(generatePath(routes.messenger));
        }
      });
  };

  return (
    <motion.div
      whileTap={{ scale: 0.9 }}
      style={{ ...giftActionButtonStyle, background: '#fff' }}
      onClick={handleRejectGift}
    >
      {isDeclining ? (
        <LottieAnimation
          width={40}
          height={40}
          animationData={loadingAnimationData}
          shouldAnimate={true}
          loop={true}
        />
      ) : (
        <>
          <span style={{ fontSize: '17px' }}>
            {t('chats.reject_gift_button')}
          </span>
        </>
      )}
    </motion.div>
  );
};

export default RejectGift;
